import { OpenChoreoIcon } from '@openchoreo/backstage-design-system';

const LogoIcon = () => {
  return <OpenChoreoIcon />;
};

export default LogoIcon;
